import { request } from './index.js'

// 管理员登录
export const login = (user_name, password) => request(`api/auth/admin_login`, 'post', {
    data: { user_name, password }
})
// 老师登录
export const teacherLogin = (user_name, password) => request(`api/auth/teacher_login`, 'post', {
    data: { user_name, password }
})

// 创建/编辑 打卡
export const saveClockIn = (data) => request(`api/admin/content/save_clock_in`, 'post', {
    data: data
})

// 打卡列表
export const getClockInList = (page) => request(`api/admin/content/clock_in_list`, 'post', {
    data: { page }
})

// 创建编辑banner
export const saveBanner = (data) => request(`api/admin/content/save_banner`, 'post', {
    data: data
})

// banner列表
export const getBannerList = (page) => request(`api/admin/content/banner_list`, 'post', {
    data: { page }
})

// 学校列表
export const getSchoolList = (page) => request(`api/admin/user/school_list`, 'post', {
    data: { page }
})

// 创建\编辑学校账号
export const saveSchool = (data) => request(`api/admin/user/save_school`, 'post', {
    data: data
})

// 删除学校账号
export const delSchool = (id) => request(`api/admin/user/delete_school`, 'post', {
    data: { id }
})

// 老师列表
export const getTeacherList = (page) => request(`api/admin/user/teacher_list`, 'post', {
    data: { page }
})
// 创建\编辑老师账号
export const saveTeacher = (data) => request(`api/admin/user/save_teacher`, 'post', {
    data: data
})

// 根据编号获取班级
export const getClassByNo = (no) => request(`api/admin/classes/classes_by_no`, 'post', {
    data: { no }
})

// 删除老师
export const delTeacher = (id) => request(`api/admin/user/delete_teacher`, 'post', {
    data: { id }
})

// 学生列表
export const getStudentList = (data) => request(`api/admin/user/student_list`, 'post', {
    data: data
})

// 班级列表
export const getClassList = (data) => request(`api/admin/classes/classes_list`, 'post', {
    data: data
})

// 创建编辑班级
export const saveClass = (data) => request(`api/admin/classes/save_classes`, 'post', {
    data: data
})

// 年级列表
export const getGrades = () => request(`api/admin/classes/grade_list`, 'post')

// 删除班级
export const delClass = (id) => request(`api/admin/classes/del_classes`, 'post', {
    data: { id }
})

// 班级下的学生列表
export const getStudentInClass = (page, classes_id) => request(`api/admin/classes/student_list`, 'post', {
    data: { page, classes_id }
})
// 班级下的老师列表
export const getTeacherInClass = (page, classes_id) => request(`api/admin/classes/teacher_list`, 'post', {
    data: { page, classes_id }
})

// 学习进度
export const getStudyProgress = (data) => request(`api/admin/study/study_progress`, 'post', {
    data: data
})

// 学习详情
export const getStudyDetail = (data) => request(`api/admin/study/progress_list_v2`, 'post', {
    data: data
})

// 文件上传
export const upload = (file) => {
    let formData = new FormData()
    formData.append('file', file)
    return request(`api/admin/file/upload`, 'post', {
        data: formData
    })
}

// 删除打卡
export const delClockIn = (id) => request(`api/admin/content/del_clock_in`, 'post', {
    data: { id }
})

// 删除banner
export const delBanner = (id) => request(`api/admin/content/del_banner`, 'post', {
    data: { id }
})

// 课程列表
export const getCourseList = (data) => request(`api/admin/course/course_list`, 'post', {
    data: data
})

// 老师解绑班级
export const unbindTeacher = (classes_id, teacher_id) => request(`api/admin/user/teacher_un_classes`, 'post', {
    data: { classes_id, teacher_id }
})

// 编辑分类
export const editCategory = (id, category) => request(`api/admin/grade/edit_category`, 'post', {
    data: { id, category }
})

//创建编辑课程
export const saveCourse = (data) => request(`api/admin/course/save_course`, 'post', {
    data: data
})

// 课程上架
export const courseShelf = (course_id, category) => request(`api/admin/course/put_shelf`, 'post', {
    data: { course_id, category }
})

// 课时列表
export const getPeriodList = (course_id, page) => request(`api/admin/course/course_period_list`, 'post', {
    data: { course_id, page }
})

// 创建编辑课时
export const savePeriod = (data) => request(`api/admin/course/save_course_period`, 'post', {
    data: data
})

// 删除课程
export const delCourse = (course_id) => request(`api/admin/course/del_course`, 'post', {
    data: { course_id }
})
// 删除课时
export const delKs = (course_period_id) => request(`api/admin/course/del_course_period`, 'post', {
    data: { course_period_id }
})
// 删除课件
export const delKj = (courseware_id) => request(`api/admin/course/del_courseware`, 'post', {
    data: { courseware_id }
})

// 课件列表
export const getKjList = (course_period_id, page) => request(`api/admin/course/courseware_list`, 'post', {
    data: { course_period_id, page }
})

// 新建编辑课件
export const saveKj = (data) => request(`api/admin/course/save_courseware`, 'post', {
    data: data
})

// 获取课程下的学生
export const getStudentInCourse = (data) => request(`api/admin/user/student_list_by_course`, 'post', {
    data: data
})

// 获取学习日志
export const getStudyLog = (data) => request(`api/admin/user/student_study_log`, 'post', {
    data: data
})

// 老师获取年级
export const teacherGetGrades = () => request(`api/config/grade`, 'post')

// 老师获取学生
export const teacherGetStudents = (data) => request(`api/teacher/info/student_list_by_teacher`, 'post', {
    data: data
})
// 老师看学生详情
export const teacherGetStudentDetail = (student_id) => request(`api/teacher/info/student_detail`, 'post', {
    data: { student_id }
})

// 获取oss上传参数
export const getSts = () => request(`api/admin/file/sts`, 'post')
export const getSts2 = () => request(`/api/teacher/file/sts`, 'post')



// 移出班级
export const remove_student = (student_id) => request(`api/teacher/info/remove_student`, 'post', {
    data: { student_id }
})
// 导入学生
export const import_student = (file) => {
    let formData = new FormData()
    formData.append('file', file)
    return request(`api/admin/user/import_student`, 'post', {
        data: formData
    })
}
// 导入列表
export const import_list = (data) => request(`api/admin/user/import_list`, 'post', {
    data
})
// 导出数据
export const student_export = (data) => request(`api/admin/user/student_export`, 'post', {
    data
})
// 新建反馈
export const createFeedback = (data, role) => {
    return request(`api/${role == 'teacher' ? 'teacher' : 'admin'}/feedback/create`, 'post', {
        data
    })
}

// 反馈列表
export const getFeedbackList = (data) => request(`api/admin/feedback/index`, 'post', { data })
